<template>
  <div
    :class="{
      'tw-py-2': true,
      'tw-cursor-pointer': clickable,
      'hover:tw-bg-slate-50': !isSelected
    }"
    data-testid="studio-person-list-item"
  >
    <div class="@container tw-group tw-relative tw-flex tw-items-center tw-transition-all hover:dark:tw-bg-slate-900">
      <StudioAvatar v-if="showAvatar" class="tw-ml-3" :name="title" :imageSrc="imageSrc" />
      <div class="tw-block tw-w-full tw-flex-1 tw-overflow-hidden tw-px-4">
        <div class="tw-truncate tw-text-sm @lg:tw-text-base">
          {{ title }}
        </div>
        <div class="tw-max-w-xl tw-truncate tw-text-xs tw-text-slate-500">
          {{ subTitle }}
        </div>
        <div v-if="subTitleSecondary" class="tw-max-w-xl tw-truncate tw-text-xs tw-text-slate-500">
          {{ subTitleSecondary }}
        </div>
      </div>

      <div class="tw-flex-none tw-pr-3 @lg:tw-pt-0">
        <slot name="right" />
      </div>
    </div>

    <div v-if="alerts.length > 0">
      <div
        v-for="alert in alerts"
        :key="alert.key"
        :data-testid="alert.key"
        class="tw-mx-2 tw-mt-2 tw-flex tw-items-center tw-rounded-lg tw-bg-yellow-100 tw-p-2 tw-px-4 tw-text-xs tw-text-yellow-700 hover:tw-cursor-auto"
        @click.stop
      >
        <ExclamationTriangle class="tw-mr-2 tw-h-4 tw-w-4" />
        <div>
          {{ alert.message }}
          <span v-if="alert.helpDoc" v-html="alert.helpDoc"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import StudioAvatar from './StudioAvatar.vue';

import ExclamationTriangle from '@/studioComponents/Icons/ExclamationTriangle.vue';

interface Alert {
  key: string;
  message: string;
  helpDoc?: string;
}

export default defineComponent({
  name: 'StudioPersonListItem',
  components: {
    StudioAvatar,
    ExclamationTriangle
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: ''
    },
    subTitleSecondary: {
      type: String,
      default: ''
    },
    imageSrc: {
      type: String,
      default: null
    },
    clickable: {
      type: Boolean,
      default: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    alerts: {
      type: Array as () => Alert[],
      default: () => []
    },
    showAvatar: {
      type: Boolean,
      default: true
    }
  }
});
</script>
